import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase-config';

function Footer() {
  const { t } = useTranslation();
  const [settings, setSettings] = useState({
    instagram: '',
    youtube: '',
    viber: '',
    whatsapp: '',
    email: '',
    phone: '',
    address: ''
  });

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsSnapshot = await getDocs(collection(db, 'settings'));
        if (!settingsSnapshot.empty) {
          setSettings(settingsSnapshot.docs[0].data());
        }
      } catch (err) {
        console.error('Error fetching settings for footer:', err);
      }
    };
    fetchSettings();
  }, []);

  return (
    <footer className='bg-black text-white py-24 px-6 font-sans'>
      <div className='max-w-7xl mx-auto flex flex-col items-center text-center'>
        
        {/* Brand */}
        <div className='mb-12'>
          <h2 className='text-2xl md:text-3xl tracking-[0.5em] font-light text-white uppercase'>
            NEJIRA ZUKIĆ WEDDINGS
          </h2>
        </div>

        {/* Social Networks & Quick Links */}
        <div className='flex flex-col items-center space-y-10 mb-12'>
          <div className='flex space-x-8'>
            {settings.instagram && (
              <a href={settings.instagram} target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-[#bfa46d] transition-all text-xl'>
                <i className='fab fa-instagram'></i>
              </a>
            )}
            {settings.youtube && (
              <a href={settings.youtube} target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-[#bfa46d] transition-all text-xl'>
                <i className='fab fa-youtube'></i>
              </a>
            )}
            {settings.whatsapp && (
              <a href={`https://wa.me/${settings.whatsapp}`} target='_blank' rel='noopener noreferrer' className='text-gray-400 hover:text-[#25D366] transition-all text-xl'>
                <i className='fab fa-whatsapp'></i>
              </a>
            )}
            {settings.viber && (
              <a href={`viber://chat?number=${settings.viber}`} className='text-gray-400 hover:text-[#7360f2] transition-all text-xl'>
                <i className='fab fa-viber'></i>
              </a>
            )}
          </div>

          <nav className='flex flex-wrap justify-center gap-x-10 gap-y-4 text-[10px] tracking-[0.3em] font-bold uppercase text-gray-500'>
            <a href="#home" className='hover:text-white transition-colors'>{t('nav.home', 'Naslovna')}</a>
            <a href="#portfolio" className='hover:text-white transition-colors'>{t('nav.portfolio', 'Portfolio')}</a>
            <a href="#packages" className='hover:text-white transition-colors'>{t('nav.packages', 'Paketi')}</a>
            <a href="#contact" className='hover:text-white transition-colors'>{t('nav.contact', 'Kontakt')}</a>
          </nav>
        </div>

        {/* Contact Info */}
        <div className='flex flex-col items-center space-y-3 mb-16'>
          <a 
            href={`mailto:${settings.email || 'info@nejirazukic.com'}`} 
            className='text-sm text-gray-400 hover:text-white transition-colors tracking-wider'
          >
            {settings.email || 'info@nejirazukic.com'}
          </a>
          {settings.phone && (
            <a 
              href={`tel:${settings.phone}`} 
              className='text-sm text-gray-400 hover:text-white transition-colors tracking-wider'
            >
              {settings.phone}
            </a>
          )}
        </div>

        {/* Copyright */}
        <div className='w-full pt-8 border-t border-white/5'>
          <p className='text-[9px] text-gray-600 font-bold tracking-[0.2em] uppercase'>
            &copy; {new Date().getFullYear()} Nejira Zukić Weddings. {t('footer.allRights', 'Sva prava zadržana.')}
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
